import React, { useContext } from "react"
import AppContext from "../../../shared/AppContext"
import { Link } from "react-router-dom"

const DemoProductCard = (props) => {
  const { imageURL, href, product } = props
  const { trackEvent } = useContext(AppContext)

  const isVenn = product.proprietaryDataset.toLowerCase() === "venn"

  return (
    <li className="demo-report-card">
      <img width="90" src={imageURL} />
      <p className="demo-report-title">{product.name}</p>

      <div className="demo-sample-data">
        <img
          width="44"
          src={
            isVenn
              ? `/static/images/interview-users.png`
              : `/static/images/user-icon.png`
          }
        />
        <p className="sample-number">
          {isVenn
            ? `${product.metadata.Speakers.length}`
            : `${product.metadata.N}`}
        </p>
        <p>{isVenn ? `INTERVIEW SAMPLE SIZE` : `SURVEY SAMPLE SIZE`} </p>
      </div>

      <Link
        className="btn etr-button-blue-gradient"
        onClick={() => {
          trackEvent(`view report clicked`, {
            productName: product.name,
            productId: product.id,
          })
        }}
        to={href}
        target="_blank"
      >
        View Report
      </Link>
    </li>
  )
}

export default DemoProductCard
